import React from 'react';
import {Row, Col, Card} from 'react-materialize';

import fever from '../../images/fever_covid19.png';
import tiredness from '../../images/tiredness_covid19.png';
import loss_of_smell from '../../images/loss_of_smell_covid19.png';
import dry_cough from '../../images/dry_cough_covid19.png';
import high_fever from '../../images/high_fever_covid19.png';
import pneumonia from '../../images/pneumonia_covid19.png';
import dificulty_breathing from '../../images/dificulty_breathing_covid19.png';


import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h4><p><b><FormattedMessage id={"symptoms_title"} defaultMessage={"Sintomas"}/></b></p></h4>
            </div>

            <div align="center" style={{padding:"25px", margin:"25px", backgroundColor:'#7f7fff', borderRadius:'50px'}}>
                <h5><p><b><FormattedMessage id={"common_symptoms_title"} defaultMessage={"Sintomas Comuns"}/></b></p></h5>
                <ul>
                    <li>• <FormattedMessage id={"common_symptoms_item_1"} defaultMessage={"Febre"}/></li>
                    <li>• <FormattedMessage id={"common_symptoms_item_2"} defaultMessage={"Cansaço"}/></li>
                    <li>• <FormattedMessage id={"common_symptoms_item_3"} defaultMessage={"Perda de olfato"}/></li>
                    <li>• <FormattedMessage id={"common_symptoms_item_4"} defaultMessage={"Tosse Seca"}/></li>
                </ul>
                <div style={{display: 'inline-flex', alignItems: 'center'}} >
                    <img src={fever} className={"img"} alt={"Febre"} width={"auto"} height={"auto"}/>
                    <img src={tiredness} className={"img"} alt={"Febre"} width={"auto"} height={"auto"}/>
                    <img src={loss_of_smell} className={"img"} alt={"Febre"} width={"auto"} height={"auto"}/>
                    <img src={dry_cough} className={"img"} alt={"Febre"} width={"auto"} height={"auto"}/>
                </div>
            </div>

            <div align="center" style={{padding:"25px", margin:"25px", backgroundColor:'#ff7f7f', borderRadius:'50px'}}>
                <h5><p><b><FormattedMessage id={"severe_symptoms_title"} defaultMessage={"Sintomas Graves"}/></b></p></h5>
                <ul>
                    <li>• <FormattedMessage id={"severe_symptoms_item_1"} defaultMessage={"Febre Alta"}/></li>
                    <li>• <FormattedMessage id={"severe_symptoms_item_2"} defaultMessage={"Pneumonia"}/></li>
                    <li>• <FormattedMessage id={"severe_symptoms_item_3"} defaultMessage={"Dificuldade respiratória"}/></li>
                </ul>
                <div style={{display: 'inline-flex', alignItems: 'center'}} >
                    <img src={high_fever} className={"img"} alt={"Febre"} width={"auto"} height={"auto"}/>
                    <img src={pneumonia} className={"img"} alt={"Febre"} width={"auto"} height={"auto"}/>
                    <img src={dificulty_breathing} className={"img"} alt={"Febre"} width={"auto"} height={"auto"}/>
                </div>
            </div>
        </Row>

        <Row>
            <div align="center">
                <a href={"/covid"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>

        

    </Card>

);

export default Sobre;